module.exports = __webpack_public_path__ + "static/media/logo.4de507f3.svg";